import { RecurringIcon } from '@lastbrand/web-ui/icons'
import { TextLink } from '@lastbrand/web-ui/text-link'
import { css } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'

import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import type { ISubscribedPlan } from '@src/quince-site-common/src/domains/Subscription'

import Link from '../link'

import type { AnchorHTMLAttributes } from 'react'

const containerCss = css({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  backgroundColor: 'paperwhite',
  paddingBlock: 'space-16',
  paddingInline: 'space-12',
  marginBottom: 'space-24',
  gap: 'space-16',
})

const contentCss = css({
  display: 'flex',
  alignItems: 'flex-start',
  gap: 'space-8',
})

const iconCss = css({ flexShrink: 0 })

const textCss = css({ textStyle: 'body-14' })

const manageLinkCss = css.raw({ flexShrink: 0 })

const ManageLink = (linkProps: AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <Link {...linkProps} withoutBaseStyle hidePointerCursor />
)

export const ProductSubscriptionDeliveryMessageDS = ({
  subscribedPlan,
  isInStock,
}: {
  subscribedPlan: ISubscribedPlan
  isInStock?: boolean
}) => {
  const { t } = useTranslation('common')

  const frequencyDisplayLabel = subscribedPlan?.frequencyDisplayLabel
  if (!frequencyDisplayLabel) {
    return null
  }

  // OOS variants and paused subscriptions don't have a deterministic next shipment — show a neutral
  // "Pending" signal instead of the cadence so shoppers don't assume the next box is already locked in.
  const showPendingDeliveryMessage = !isInStock || subscribedPlan.status === 'PAUSED'
  const deliveryMessage = showPendingDeliveryMessage
    ? `${t('subscribed')}: ${t('next_order_pending')}`
    : `${t('subscribed')}: ${t('ships_every_frequency', { frequency: frequencyDisplayLabel })}`

  return (
    <div className={containerCss}>
      <div className={contentCss}>
        <RecurringIcon size="20px" className={iconCss} />
        <p className={textCss}>{deliveryMessage}</p>
      </div>
      <TextLink size="lg" LinkComponent={ManageLink} href={`/${PAGE_PATH.MY_SUBSCRIPTIONS}`} css={manageLinkCss}>
        {t('manage')}
      </TextLink>
    </div>
  )
}

export default ProductSubscriptionDeliveryMessageDS
